export default "__VITE_ASSET__DzeCxBIY__"